import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoadingSpinnerService } from '../services/loading-spinner.service';


@Injectable()
export class LoadingSpinnerInterceptor implements HttpInterceptor {
    constructor(public loadingSpinnerService: LoadingSpinnerService) { }

    // eslint-disable-next-line @typescript-eslint/naming-convention
    public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        this.loadingSpinnerService.Show();

        return next.handle(request).pipe(
            finalize(() => {
                this.loadingSpinnerService.Hide();
            })
        );
    }
}
